/**
 * @file
 *
 */

(function(){

  // Set globals
  var cartId = urlQuery('order');
  var $app = $(document.getElementById('ParticipantSelectorApp'));
  var products = null;
  var campers = null;
  var locale = $app.data('locale') || 'en-US';
  var translationsUrl = $app.data('translationsUrl') || '/{locale}.translations.json';
  var translations = {};
  var _configTranslation = {};
  var productsWithOutCampers = [];
  var defaultCamper = "guest";

  var _config = {
    howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
    cartCountSelector:             '.site-header__cart-count_number, .cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
    cartTotalSelector:             '#cart-price',
    feedbackPosition:              'nextButton',
    addToCartBtnSelector:          '#addToCart',
    addToCartFormSelector:         'form[action="/cart/add"]',
    shopifyAjaxAddURL:             '/cart/add.js',
    shopifyAjaxCartURL:            '/cart.js',
    shopifyAjaxUpdateURL:          '/cart/update.js',
    addCamperBtnSelector:          '#addCamper',
    addCamperFormSelector:         '.new-camper',
    addCamperSelectSelector:       '#SingleOptionSelector-Camper',
    addCamperSelectLabelSelector:  '.participant-label',
    addCamperSelectArrowSelector:  '#SingleOptionSelector-Camper-Arrow',
    crmCampType:				           'CRM - Camp',
  };

  /**
   * Primary initialization handler to kick off rendering
   */
  function init() {
    // Get translations for this UI
    getTranslations(function(err, data) {
      if (err) {
        return handleError('An error occured while retriving translations for this page.');
      }

      // Set the global
      translations = data;
      _configTranslation = {
        // What you might want to change
        addToCartBtnLabel: translations.add_to_cart_product_page,
        addedToCartBtnLabel: translations.thank_you,
        addingToCartBtnLabel: translations.adding,
        soldOutBtnLabel: translations.sold_out,
      };
      // Call API to be sure Shopify items created.
      getShopifyCart(handleCartResponse);
    });
  }

  var showFeedback = function(success, html, $addToCartForm) {
    $('.ajaxified-cart-feedback').remove();
    var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
    switch (_config.feedbackPosition) {
      case 'aboveForm':
        $addToCartForm.before(feedback);
        break;
      case 'belowForm':
        $addToCartForm.after(feedback);
        break;
      case 'nextButton':
      default:
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
        break;
    }
    // If you use animate.css
    // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
    $('.ajaxified-cart-feedback').slideDown();
  };
  var setText = function($button, label) {
    if ($button.children().length) {
      $button.children().each(function() {
        if ($.trim($(this).text()) !== '') {
          $(this).text(label);
        }
      });
    }
    else {
      $button.val(label).text(label);
    }
  };

  $(_config.addCamperFormSelector).submit(function(e) {
    e.preventDefault();
    var $form = $(this);
    var data = $form.serializeArray();

    data = objectifyForm(data);
    data['id'] = 'participant_' + findNextIndex();
    var today = new Date();
    var dob = new Date(data.dob);
    data['age'] = today.getFullYear() - dob.getFullYear();
    addParticipantsObject(data);


    for(camper of campers) {
      delete camper.shopifyProducts;
    }
    updateAttributesToCart('participants', JSON.stringify(campers));

    let value = data.first_name + ' ' + data.last_name + '(' + data.age + ')';
    let $option = $('<option>', {value: data.id, selected: 'true' }).text(value);
    $(_config.addCamperSelectSelector).append($option);
    $(_config.addCamperSelectSelector).removeClass("hide");
    $(_config.addCamperSelectArrowSelector).removeClass("hide");
    $(_config.addCamperSelectSelector).attr("disabled", false);
    $(_config.addToCartBtnSelector).attr("disabled", false);

    let $addNewCamper = $('<a>');
    $addNewCamper.text(translations.add_new);
    $addNewCamper.on('click', handleAddNewCamperOpenModal);
    $(_config.addCamperSelectLabelSelector).html('').text(translations.select_camper).append($addNewCamper);

    $.modal.close();
  });

  function findNextIndex() {
    let ids = campers.map((item) => {return parseInt(item.id.replace('participant_', ''))});

    ids = ids.filter(function (value) {
      return !Number.isNaN(value);
    });

    return ids.length ? Math.max.apply(Math, ids) + 1 : 0;
  }

  function addParticipantsObject(camper) {
    campers.push({
      id: camper.id,
      first_name: camper.first_name,
      last_name: camper.last_name,
      age: camper.age,
      dob: camper.dob,
      gender: camper.gender,
      email: camper.email,
      phone: camper.phone,
      shirt_size: camper.shirt_size
    })
  }

  function objectifyForm(formArray) {//serialize data function

    var returnArray = {};
    for (var i = 0; i < formArray.length; i++){
      returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
  }

  function updateAttributesToCart(attribute, value) {
    var postData = {};
    var cartKey = "attributes["+attribute+"]";
    postData[cartKey] = value;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: postData,
      success: function(data) {
        if (typeof callback === 'function') {
          callback(null, data);
        }
      },
      error: function(jqXHR, textStatus) {
        var err = jqXHR.responseJSON || textStatus;
        callback(err);
      }
    });
  }

  $(_config.addToCartFormSelector).submit(function(e) {
    e.preventDefault();
    var $addToCartForm = $(this);
    var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
    var producttype = $addToCartBtn.data('producttype');

    // Intercept for IMGA+ 1:1 products to collect student info via popup
    if (producttype === 'IMGA+ - 1:1' && !window._imgaPlusPopupCompleted) {
      openStudentInfoPopup(function() {
        $addToCartForm.trigger('submit');
      });
      return;
    }
    window._imgaPlusPopupCompleted = false;

    if (!$addToCartForm[0].checkValidity()) {
      $addToCartForm[0].reportValidity();
      return;
    }

    var data = $addToCartForm.serializeArray();
    setText($addToCartBtn, _configTranslation.addingToCartBtnLabel);
    $addToCartBtn.addClass('disabled').prop('disabled', true);

    //create params
    var params = {
      quantity: data[1].value,
      id: data[0].value
    };

    params.properties = {
      _participant_id: $(document.getElementById("SingleOptionSelector-Camper")).children("option:selected").val() || defaultCamper
    };

    const playerLastNameEl = document.getElementById("custom-player-last-name");
    if (playerLastNameEl && $(playerLastNameEl).val()) {
      params.properties._jersey_last_name = $(playerLastNameEl).val();
    }

    const studentsLastNameEl = document.getElementById("custom-students-name");
    if (studentsLastNameEl && $(studentsLastNameEl).val()) {
      params.properties._custom_students_name = $(studentsLastNameEl).val();
    }

    const studentLastNameEl = document.getElementById("custom-student-name");
    if (studentLastNameEl && $(studentLastNameEl).val()) {
      params.properties._custom_student_name = $(studentLastNameEl).val();
    }

    const studentStudentEmailEl = document.getElementById("custom-student-email");
    if (studentStudentEmailEl && $(studentStudentEmailEl).val()) {
      params.properties._custom_student_email = $(studentStudentEmailEl).val();
    }

    const studentPhoneEl = document.getElementById("custom-student-phone");
    if (studentPhoneEl && $(studentPhoneEl).val()) {
      params.properties._custom_student_phone = $(studentPhoneEl).val();
    }

    const guesLastNameEl = document.getElementById("custom-guest-name");
    if (guesLastNameEl && $(guesLastNameEl).val()) {
      params.properties._custom_guest_name = $(guesLastNameEl).val();
    }

    // for paver data capture

    for (let i = 1; i <= 9; i++) {
      const el = document.getElementById(`custom-line-${i}`);
      if (el && $(el).val()) {
        params.properties[`_ccustom_line_${i}`] = $(el).val();
      }
    }

    var isupdatecart = false;
    var producttype = $addToCartBtn.data('producttype');
    if(producttype=='Camp Pass'){
      var url_params = new URLSearchParams(window.location.search);
      if(url_params.get('email')){
        isupdatecart = true;
        var props = {
          email: url_params.get('email'),
          first_name: url_params.get('firstName'),
          last_name: url_params.get('lastName'),
          contact_number: url_params.get('phoneNumber'),
          address: {
            country: url_params.get('parentCountry'),
            zipcode: url_params.get('parentZipcode'),
          },
          marketing_data: {
            cRMChannel: url_params.get('cRMChannel'),
            cRMName: url_params.get('cRMName'),
            cRMPointofEntry: url_params.get('cRMPointofEntry'),
            cRMSource: url_params.get('cRMSource'),
            cRMSpecificLeadGate: url_params.get('cRMSpecificLeadGate'),
            cRMTacticName: url_params.get('cRMTacticName'),
            cRMTactic: url_params.get('cRMTactic'),
            cRMOptedIn: url_params.get('cRMOptedIn'),
            cRMLeadGateLocation: url_params.get('cRMLeadGateLocation'),
          },
        };
        var participantsData = {
          'attributes': {
            'customer': props,
            'whatdo': 'UpdateCart',
          }
        };
      }
    }

    //Add to cart.
    $.ajax({
      url: _config.shopifyAjaxAddURL,
      dataType: 'json',
      type: 'post',
      data: params,
      success: function(itemData) {
        console.log('add_to_cart_itemData:',itemData);

        if (producttype === 'Camp Pass' && typeof window.pushCampBuilderLead === 'function') {
          var _psParams = new URLSearchParams(window.location.search);
          window.pushCampBuilderLead({
            email: _psParams.get('email'),
            phone: _psParams.get('phoneNumber'),
            interest: _psParams.get('businessType'),
            sport: _psParams.get('sport'),
            product_type: producttype,
            event_id: (itemData && itemData.id) || _psParams.get('variant')
          });
        }

        // Re-enable add to cart button.
        $addToCartBtn.addClass('inverted');
        setText($addToCartBtn, _configTranslation.addedToCartBtnLabel);
        showFeedback('success','<i class="fa fa-check"></i> '+translations.added_to_cart+' <a href="/cart">'+translations.add_to_cart+'</a> '+translations.or+'  <a href="/">'+translations.continue_shopping+'</a>.',$addToCartForm);
        window.setTimeout(function(){
          $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
          setText($addToCartBtn,_configTranslation.addToCartBtnLabel);
        }, _config.howLongTillBtnReturnsToNormal);
        // Update cart count and show cart link.
        $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
          updateCartItemsNumber(cart);
          updateGlobalCart(cart);
          if(isupdatecart){
            var postData = {};
            postData["attributes[customer]"] = JSON.stringify(participantsData.attributes.customer);
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: postData,
            });
          }
        });
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        if (response.slice(0,4) === 'All ') {
          showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
          $addToCartBtn.prop('disabled', false);
          setText($addToCartBtn, _configTranslation.soldOutBtnLabel);
          $addToCartBtn.prop('disabled',true);
        }
        else {
          showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
          $addToCartBtn.prop('disabled', false).removeClass('disabled');
          setText($addToCartBtn, _configTranslation.addToCartBtnLabel);
        }
      }
    });
    return false;
  });

  function updateCartItemsNumber (cart) {
    if (_config.cartCountSelector && $(_config.cartCountSelector).length) {
      let value = $(_config.cartCountSelector).html() || '0';
      $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
    }
  }

  function getShopifyCart(callback) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: "json",
      success: function(data) {
        callback(null, data);
      },
      error: function(jqXHR, textStatus) {
        console.log('Error retrieving cart: ' + cartId, err);
        callback(err);
      }
    });
  }

  function handleCartResponse(err, data) {
    // If the Shopify AJAX API returns an error stop and handle it
    if (err) {
      return handleError(translations.error_cart_retrieval);
    }

    // Attempt to validate the cart and set the participant globally
    try {
      //participant = validateCartAndGetParticipant(data);
    } catch(err) {
      // The error will be user-friendly so pass it through
      return handleError(err);
    }

    products = data.items;

    if(checkCampProducts()) {
      campers = getProductsPerParticipants(data.attributes);

      var $selector = getCamperSelector();


      $app
        .html('') // Remove loading text
        .append($selector)
        .hide()
        .fadeIn();
    }
    $(_config.addToCartBtnSelector).attr("disabled", false);


  }

  function checkCampProducts () {
    return products.find((item) => {
      return item.product_type === _config.crmCampType
    })
  }

  function handleAddNewCamperOpenModal() {
    $('#add-camper-modal').modal({
      fadeDuration: 250
    });
  }

  function getCamperSelector()
  {
    let $div = $('<div>', {class: 'selector-wrapper product-selector js'});
    let $label = $('<label>', {for: 'SingleOptionSelector-Camper'});
    let $selector = $('<select>', {id: 'SingleOptionSelector-Camper', class: 'product-selector-button-select', 'style': 'width: auto; padding-right: 50px;' });
    let $arrow = $('<span>', {id: 'SingleOptionSelector-Camper-Arrow', class: 'product-selector-button icon-arrow-down'});

    if(campers.length) {
      // let $addNewCamper = $('<a>');
      //
      // $addNewCamper.text('add new.');
      //
      // $addNewCamper.on('click', handleAddNewCamperOpenModal);
      var labelText = $('<span>', {class: 'participant-label'}).text(translations.select_camper);
    }
    //else {
    //   $selector.attr("disabled", true);
    //   $selector.addClass("hide");
    //   $arrow.addClass("hide");
    //   $(_config.addToCartBtnSelector).attr("disabled", true);
    //   let $addNewCamper = $('<a>');
    //
    //   $addNewCamper.text('add new participant.');
    //
    //   $addNewCamper.on('click', handleAddNewCamperOpenModal);
    //   var labelText = $('<span>', {class: 'participant-label'}).text('Please ').append($addNewCamper);
    // }

    $label.append(labelText);

    let $defaultOption = $('<option>', {value: 'guest' }).text(translations.do_not_add_to_camp_reservation);

    $selector.append($defaultOption);
    for(let camper of campers) {
      let value = camper.first_name + ' ' + camper.last_name + '(' + camper.age + ')';
      let $option = $('<option>', {value: camper.id }).text(value);
      $selector.append($option)
    }

    return $div
      .append($label)
      .append($selector)
      .append($arrow)
  }

  function getProductsPerParticipants (attributesString) {
    let campers = [];
    if(attributesString.participants) {
      campers = $.parseJSON(attributesString.participants);

      for (let i = 0; i < campers.length; i++) {
        campers[i].shopifyProducts = [];
      }

      for (product of products) {
        let camper = campers.find(function (camper) {
          if(product.properties && (product.properties.participant_id || product.properties._participant_id)) {
            return (camper.id === (product.properties.participant_id || product.properties._participant_id))
          }
        })


        product['lineIndex'] = getShopifyProductLine(product) + 1;
        if (camper) {
          camper.shopifyProducts.push(product);
          continue;
        }
        productsWithOutCampers.push(product);
      }

      for (let i = 0; i < campers.length; i++) {
        campers[i].price_total = calculateSubTotal(campers[i].shopifyProducts, 'line_price');
        campers[i].shopifyProducts.sort(function (a, b) {
          return a.lineIndex - b.lineIndex
        });
      }
    }
    return campers;
  }

  function getShopifyProductLine(product) {
    return products.findIndex (function(shopifyProduct) {
      return (shopifyProduct.id === product.shopify_id);
    });
  }

  /**
   * Get content
   *
   * @param {*} callback
   */
  function getTranslations(callback) {
    var url = translationsUrl.t({ locale: locale });

    $.ajax({
      url: url,
      type: 'GET',
      success: function(data) {
        callback(null, data);
      },
      error: function(jqXHR, textStatus) {
        var err = jqXHR.responseJSON || textStatus;
        console.log('Error retrieving translations: ' + url, err);
        callback(err)
      }
    });
  }

  function calculateSubTotal (items, prop) {
    if (items == null) {
      return 0;
    }
    return items.reduce(function (a, b) {
      return b[prop] == null ? a : a + b[prop];
    }, 0);
  };

  /**
   * Custom class to initiate an overlay (intended for use while adding items to the cart)
   */
  function Overlay(config) {

    // Provide configuration defaults and allow user to override
    this.config = $.extend({
      content: null,
      loader: false,
      class: null
    }, config);

    /**
     * Build the initial overlay
     */
    this.build = function() {

      var $overlayContent = $('<div>', { class: 'content' });

      // If the user has requested a loader create it and append
      if (this.config.loader) {
        var $loaderIcon = $('<div>', { class: 'loader-icon' });
        $overlayContent.append($loaderIcon);
      }

      // The user has provided a jQuery object append it
      if (this.config.content
        && this.config.content instanceof jQuery) {

        var $overlayContentInner = $('<div>', { class: 'inner' });
        $overlayContentInner.append(this.config.content);
        $overlayContent.append($overlayContentInner);
      }

      // Or if the user has supplied a string create markup and append it
      if (this.config.content
        && typeof this.config.content === 'string') {

        var $loaderText = $('<p>', { class: 'loader-text' });
        $loaderText.text(this.config.content);
        $overlayContent.append($loaderText);
      }

      var classes = 'overlay';

      if (this.config.class) {
        classes += ' ' + this.config.class;
      }

      // Assign the overlay object and append it
      return $('<div>', { class: classes })
        .append($overlayContent)
        .hide();
    }

    /**
     * Primary open method to display the overlay
     */
    this.open = function() {
      this.$overlay.fadeIn();
    }

    /**
     * Primary close method to hide the overlay
     */
    this.close = function() {
      this.$overlay.fadeOut();
    }

    // Kick off the primary functionality
    this.$overlay = this.build();
    $('body').append(this.$overlay);
  }

  /**
   * Custom class to initiate loading indicators inline (intended for use while removing items)
   */
  function Loader($wrapper) {

    this.$loader = $('<span>', { class: 'loader-icon-small' });
    $wrapper.append(this.$loader);

    this.loading = function() {
      this.$loader.addClass('active');
    };

    this.loaded = function() {
      this.$loader.removeClass('active');
    }
  }

  /**
   * Retrieves URL parameters based on a given parameter name
   *
   * @param {*} name
   */
  function urlQuery(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
      return null;
    }
    return decodeURIComponent(results[1]) || null;
  }

  /**
   * Global error handler to manage behaviors
   *
   * @param {*} errorMsg
   */
  function handleError(errorMsg) {

    // Construct the default error message
    if (!errorMsg) {
      errorMsg = translations.error_default;
    }

    // Append evergreen message after the user supplied error
    errorMsg += ' ' + translations.error_append;

    // Create the baseline error markup with the contructed message and add to DOM
    var $content = $('<div>', { class: 'error-content' });
    var $error = $('<p>', { class: 'error-text' });
    $error.html(errorMsg);
    $content.append($error);

    // Create the default actions markup and add to DOM
    var $errorBtns = $('<div>', { class: 'overlay-actions' });
    var $reloadBtn = $('<a>', {
      class: 'btn',
      href: '#'
    });
    $reloadBtn.text(translations.error_reload);
    $errorBtns.append($reloadBtn);

    // Reload the page if user requests a reload
    $reloadBtn.on('click', function(e) {
      e.preventDefault();
      location.reload();
    });

    // If the page was loaded with a redirect URL trigger it
    // if (redirectUrl) {
    //   var $backBtn = $('<a>', {
    //     class: 'btn',
    //     href: redirectUrl
    //   });
    //   $backBtn.text(translations.error_back);
    //   $errorBtns.append($backBtn);
    // }

    // Add the error message and buttons to the DOM
    $content
      .append($error)
      .append($errorBtns);

    // Create the overlay to hold the error and open it
    var errorOverlay = new Overlay({ content: $content });
    errorOverlay.open();
  }

  function compare(a, b) {
    if (a > b) return +1;
    if (a < b) return -1;
    return 0;
  }

  /**
   * Replaces tokens in brackets {} inside strings for translations
   *
   * Usage 'Some {foo}'.t({ foo : 'Bar' });
   *
   * Results in Some Bar
   */
  String.prototype.t = function(o) {
    var regexp = /{([^{]+)}/g;

    return this.replace(regexp, function(ignore, key){
      return (key = o[key]) == null ? '' : key;
    });
  }

  /**
   * Capitalizes the first character in a string
   */
  String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  }

  init();

})();


var _init = function() {
  $(document).ready(function() {
    $(_config.addToCartFormSelector).submit(function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);

      if (!$addToCartForm[0].checkValidity()) {
        $addToCartForm[0].reportValidity();
        return;
      }

      var data = $addToCartForm.serialize();
      var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
      setText($addToCartBtn, _configTranslation.addingToCartBtnLabel);
      $addToCartBtn.addClass('disabled').prop('disabled', true);
      // Add to cart move to participantSelector.
    });
    return false;
  });
};
